<template>
		<div style="width:100%;height:100vh;display:flex;justify-content:center;align-items:center;background-color:#F5F5F5;">
			<div style="background-color:#ffffff;text-align:left;height:100%;">
				<div style="font-size:32px;margin:30px 20px;">微信登录</div>
				<div style="text-align:center;border-radius:10px;box-shadow: 0 0 0.48rem 0 rgba(0,0,0,.08);padding:40px 60px;margin:30px 20px;font-size:20px;">
					<img :src="url+public.url" v-if="public" style="width:300px;height:300px;"/>
					<div>请使用微信扫描二维码登录</div>
					<div>查看更多详情</div>
				</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"my",
		components:{
		},
		data() {
			return {
				url:'',
				public:''
			}
		},
		created() {
			//获取系统信息
			const data={
				field:['blog','college','public','curriculum','books','weapon','ideal','school','character','character_src']
			}
			axios({
			    url: `${base.url}/api/user/getRule`,
			    method: 'post',
			    data:data
			}).then((res) => {
				console.log(res);
					 this.url=res.url
					 this.public=res.data.public[0]
			        })
		},
		methods: {
		
		},
	}
</script>

<style lang="scss" >
	body{
		width:100%;
		height:100%;
	}
</style>
